module.exports = __webpack_public_path__ + "03_mole.b005fdfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer2/03_mole.png
// module id = 1ROR
// module chunks = 0